import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Testimonials = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const testimonials = [
    {
      name: "Budi Santoso",
      title: "Trader Retail",
      testimonial: "Saya sudah coba berbagai sistem trading tapi selalu inconsistent hasilnya. Setelah belajar News Hack, profit saya jadi stabil. Dalam 1 bulan terakhir, rata-rata profit 200-300 pips per minggu!",
      initials: "BS"
    },
    {
      name: "Diana Putri",
      title: "Part-time Trader",
      testimonial: "Sebagai ibu rumah tangga dengan 2 anak, saya butuh sistem trading yang tidak makan waktu. News Hack perfect banget, cukup trading 1-2 jam saat news, hasilnya bisa menutupi pengeluaran rumah tangga bulanan.",
      initials: "DP"
    },
    {
      name: "Reza Mahendra",
      title: "Trader & Pengusaha",
      testimonial: "Awalnya skeptis dengan tingkat keberhasilan yang dijanjikan. Tapi setelah coba sendiri selama 3 bulan, memang akurat! Dari modal awal $2000, akun saya sudah tumbuh jadi $8500.",
      initials: "RM"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  return (
    <section className="py-20 gradient-bg-reverse" id="testimonials">
      <div className="container max-w-7xl mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.7 }}
          className="text-4xl md:text-5xl font-bold text-center mb-16"
        >
          Testimoni <span className="highlight">Trader</span>
        </motion.h2>
        
        <motion.div 
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          className="space-y-8 max-w-5xl mx-auto"
        >
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index}
              variants={itemVariants}
              whileHover={{ y: -5, boxShadow: "0 20px 30px rgba(0, 0, 0, 0.3)" }}
              className="card-gradient border border-primary/20 rounded-xl p-8 flex gap-6"
            >
              <div className="w-20 h-20 rounded-full bg-darkerBlue border-2 border-primary flex items-center justify-center text-primary font-bold text-2xl flex-shrink-0">
                {testimonial.initials}
              </div>
              <div>
                <p className="text-lg md:text-xl italic mb-6 relative leading-relaxed text-textGray">
                  <span className="absolute -left-8 top-0 text-primary/30 text-4xl">"</span>
                  {testimonial.testimonial}
                </p>
                <div>
                  <h4 className="text-lg md:text-xl highlight font-bold">{testimonial.name}</h4>
                  <p className="text-base md:text-lg text-gray-400">{testimonial.title}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.p 
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 0.6 } : { opacity: 0 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="text-center text-base md:text-lg text-gray-400 mt-16 max-w-4xl mx-auto leading-relaxed"
        >
          *Testimonial di atas adalah pengalaman nyata dari trader yang telah menerapkan teknik News Hack. Hasil trading dapat bervariasi tergantung kondisi pasar dan kemampuan individual.
        </motion.p>
      </div>
    </section>
  );
};

export default Testimonials;